import React from 'react';
import styled from 'styled-components';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 16px;
  padding: 2rem;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  position: relative;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
`;

const CloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: #f3f4f6;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 1.2rem;
  color: #6b7280;
  transition: all 0.2s ease;
  
  &:hover {
    background: #e5e7eb;
    color: #1f2937;
  }
`;

const TeamName = styled.h3`
  margin: 0;
  color: #1f2937;
  font-size: 1.25rem;
  font-weight: 600;
  text-align: center;
`;

const LogoImage = styled.img`
  max-width: 500px;
  max-height: 500px;
  width: auto;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  object-fit: contain;
  
  @media (max-width: 768px) {
    max-width: 80vw;
    max-height: 60vh;
  }
`;

const LogoPlaceholder = styled.div`
  width: 300px;
  height: 300px;
  border-radius: 12px;
  background: linear-gradient(135deg, #043663 0%, #0a4d7a 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 4rem;
  font-weight: 700;
  text-transform: uppercase;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  
  @media (max-width: 768px) {
    width: 60vw;
    height: 60vw;
    font-size: 3rem;
  }
`;

const TeamLogoModal = ({ isOpen, onClose, logoUrl, teamName, teamInitials }) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <ModalOverlay onClick={handleOverlayClick}>
      <ModalContent>
        <CloseButton onClick={onClose} aria-label="Close modal">×</CloseButton>
        {teamName && <TeamName>{teamName}</TeamName>}
        {logoUrl ? (
          <LogoImage src={logoUrl} alt={`${teamName || 'Team'} logo`} />
        ) : (
          <LogoPlaceholder>
            {teamInitials || 'TM'}
          </LogoPlaceholder>
        )}
      </ModalContent>
    </ModalOverlay>
  );
};

export default TeamLogoModal;

